import Resource from './Resource';
import {BaseSignableDocuments} from "./SignableDocuments";

/**
 * CourtesyCarReservation Resource
 */
class CourtesyCarReservation extends Resource
{
    constructor() {
        super('reservation', ['courtesy-car-reservations']);
    }

    options(params) {
        return this._doGet(['options'], params);
    }

    availability(params) {
        return this._doGet(['availability'], params)
    }

    bookout(id, instance_id, driving_license_number) {
        return this._doPost([id, 'book-out'], { instance_id, driving_license_number })
    }

    bookin(id, params) {
        return this._doPost([id, 'book-in'], {}, params)
    }
}

export let CourtesyCarReservationResource = new CourtesyCarReservation();

export class SignableCourtesyCarDocuments extends BaseSignableDocuments
{
    constructor() {
        super('courtesy-car-reservations');
    }
}

export let SignableCourtesyCarDocumentsResource = new SignableCourtesyCarDocuments()

/**
 * CourtesyCarReservation Schema
 * @param {Object} defaults [description]
 */
export let CourtesyCarReservationSchema = function(defaults = {}) {
    let schema = {
        contact_id: null,
        instance_id: null,
        driving_license_number: null,
        requires_automatic: false,
        booked_out_at: null,
        booked_out_by_id: null,
        booked_in_at: null,
        booked_in_by_id: null,
    };

    if (defaults) {
        schema = Object.assign(schema, defaults);
    }

   return schema;
};